export default __webpack_public_path__ + "static/media/CCTV.4571c38d.svg";